import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'whatwg-fetch';
import 'es6-promise/auto';

import React from 'react';
import ReactDOM from 'react-dom';
import {
    BrowserRouter as Router,
    Switch,
    Route,
} from 'react-router-dom';
import App from './App';
import RegistrationPage from './Registration/RegistrationPage';

const router = (
    <Router>
        <Switch>
        <Route exact={true} path="/registration/*" component={RegistrationPage} />
        <Route path="/" component={App} />
        </Switch>
    </Router>
);

/* istanbul ignore file */
ReactDOM.render(router, document.getElementById('root'));